<div class="d-flex flex-column">
  <div class="mb-2">
    <div class="d-flex item-box shadow">
      <div>
        <em class="las la-calendar text-white fs-4"></em>
      </div>
      <div class="my-auto">
        <p class="mb-0 text-white ms-3 fs-5">{{time | date: 'mediumDate'}}</p>
      </div>
    </div>
  </div>

  <div class="mb-2">
    <div class="d-flex item-box shadow">
      <div>
        <em class="las la-clock text-white fs-4"></em>
      </div>
      <div class="my-auto">
        <p class="mb-0 text-white ms-3 fs-5">{{time | date: 'shortTime'}}</p>
      </div>
    </div>
  </div>

  <!-- <div class="">
    <div class="d-flex item-box shadow">
      <div>
        <em class="las la-money-bill text-white fs-4"></em>
      </div>
      <div class="my-auto">
        <p class="mb-0 text-white ms-3 fs-5">{{totalRevenue | currency: 'Rs.'}}</p>
      </div>
    </div>
  </div> -->

  <div class="mb-2 cursor" (click)="onPendingOrders()">
    <div class="d-flex item-box shadow">
      <div>
        <em class="las la-hamburger text-white fs-4"></em>
      </div>
      <div class="my-auto">
        <p class="mb-0 text-white ms-3 fs-5 text-decoration-underline" >{{numberOfOrders | number}} Pending Orders</p>
      </div>
    </div>
  </div>
</div>
